import { create } from 'zustand';

import { getPersistedSearch } from '../hooks/usePersistedSearch';

interface SearchState {
  search: string;
  setSearch: (search: string) => void;
}

export const useSearchStore = create<SearchState>((set) => ({
  search: getPersistedSearch() || '',
  setSearch: (search: string) => set({ search }),
}));
